/** 用户手册：独立页，不走 layout，需登录后访问 */
const routes = [
  {
    path: '/userManual',
    name: 'UserManual',
    component: () => import('@/views/UserManual/Index.vue'),
    hiddenInMenu: true,
    meta: {
      title: '用户手册',
      roles: [1]
    }
  }
]

export default routes
